import React, { useRef } from 'react';

const TabBar = ({ tabs, currentTab, setCurrentTab, vertical = false, icons = {} }) => {
  const tabsRef = useRef(null);

  const scrollBy = x => {
    const index = tabs.indexOf(currentTab);
    tabsRef.current.scrollLeft += x;

    if (x < 0 && index > 0) {
      setCurrentTab(tabs[index - 1]);
    }

    if (x > 0 && index < tabs.length - 1) {
      setCurrentTab(tabs[index + 1]);
    }
  };

  if (vertical) {
    return (
      <div className="flex flex-col w-64 h-full overflow-y-auto bg-white text-gray-800">
        <div className="flex items-center justify-center h-20 border-b mb-4 border-gray-200">
          {/* Placeholder for Logo if needed, or just space */}
          <h1 className="text-xl font-bold tracking-wider text-gray-800">MAHMOR RESUME</h1>
        </div>

        {tabs.map(tab => (
          <div
            key={tab}
            className={`
              flex items-center px-6 py-4 cursor-pointer transition-all duration-200 group
              ${currentTab === tab
                ? 'bg-teal-50 border-l-4 border-teal-500 text-teal-600'
                : 'text-gray-500 hover:bg-gray-50 hover:text-teal-600 border-l-4 border-transparent'
              }
            `}
            onClick={() => setCurrentTab(tab)}
          >
            <i className={`material-icons mr-4 text-2xl transition-colors duration-200 ${currentTab === tab
              ? 'text-teal-600'
              : 'text-gray-400 group-hover:text-teal-600'
              }`}>
              {icons[tab] || 'lens'}
            </i>
            <span className="font-medium text-sm tracking-wide">{tab}</span>
          </div>
        ))}

        <div className="mt-auto flex flex-col items-center pb-6">
          <div className="text-xs text-gray-400">
            v2.0.0
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-4 mb-6 flex items-center">
      <div
        className="flex mr-1 cursor-pointer select-none text-gray-600 hover:text-gray-800"
        onClick={() => scrollBy(-100)}
      >
        <i className="material-icons">chevron_left</i>
      </div>

      <ul id="tabs" ref={tabsRef} className="flex overflow-x-scroll no-scrollbar">
        {tabs.map(tab =>
          currentTab === tab ? (
            <li key={tab} className="mx-1 list-none">
              <div className="whitespace-no-wrap bg-teal-600 text-white shadow-lg rounded-full text-sm py-2 px-6 font-medium transition-all duration-300">
                {tab}
              </div>
            </li>
          ) : (
            <li key={tab} className="mx-1 list-none">
              <div
                className="whitespace-no-wrap rounded-full cursor-pointer text-sm py-2 px-6 font-medium text-gray-600 hover:text-teal-600 hover:bg-teal-50 transition-colors duration-300"
                onClick={() => setCurrentTab(tab)}
              >
                {icons[tab] && <i className="material-icons mr-2 align-middle text-sm">{icons[tab]}</i>}
                {tab}
              </div>
            </li>
          ),
        )}
      </ul>

      <div
        className="flex ml-1 cursor-pointer select-none text-gray-600 hover:text-gray-800"
        onClick={() => scrollBy(100)}
      >
        <i className="material-icons">chevron_right</i>
      </div>
    </div>
  );
};

export default TabBar;
